import { Controller } from "@hotwired/stimulus";

// Tiny controller for the "edit avatar/logo" button overlaid on a hero card.
// The button triggers a hidden file input; on file selection the surrounding
// form auto-submits (Turbo handles the response).
export default class extends Controller {
  static targets = ["input", "form"];

  pick(event) {
    event.preventDefault();
    this.inputTarget.click();
  }

  submit() {
    if (this.inputTarget.files && this.inputTarget.files.length > 0) {
      this.formTarget.requestSubmit();
    }
  }
}
